"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useVirtualizerScrollViewStyles_unstable: function() {
        return useVirtualizerScrollViewStyles_unstable;
    },
    virtualizerScrollViewClassNames: function() {
        return virtualizerScrollViewClassNames;
    }
});
const _useVirtualizerStylesstyles = require("../Virtualizer/useVirtualizerStyles.styles");
const _react = require("@griffel/react");
const virtualizerScrollViewClassName = 'fui-Virtualizer-Scroll-View';
const virtualizerScrollViewClassNames = {
    ..._useVirtualizerStylesstyles.virtualizerClassNames,
    container: `${virtualizerScrollViewClassName}__container`
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        mc9l5x: "f22iagw",
        a9b677: "fly5x3f",
        Bqenvij: "f1l02sjl"
    },
    vertical: {
        Beiy3e4: "f1vx9l62",
        Bmxbyg5: "f5zp4f"
    },
    horizontal: {
        Beiy3e4: "f1063pyq",
        B68tc82: "f1oy3dpc"
    },
    verticalReversed: {
        Beiy3e4: "f1gkdon0",
        Bmxbyg5: "f5zp4f"
    },
    horizontalReversed: {
        Beiy3e4: "f1oztnx0",
        B68tc82: "f1oy3dpc"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".fly5x3f{width:100%;}",
        ".f1l02sjl{height:100%;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f5zp4f{overflow-y:auto;}",
        ".f1063pyq{flex-direction:row;}",
        ".f1oy3dpc{overflow-x:auto;}",
        ".f1gkdon0{flex-direction:column-reverse;}",
        ".f1oztnx0{flex-direction:row-reverse;}"
    ]
});
const useVirtualizerScrollViewStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    // Default virtualizer styles base
    (0, _useVirtualizerStylesstyles.useVirtualizerStyles_unstable)(state);
    const containerStyle = state.axis === 'horizontal' ? state.reversed ? styles.horizontalReversed : styles.horizontal : state.reversed ? styles.verticalReversed : styles.vertical;
    // Add container styles
    state.container.className = (0, _react.mergeClasses)(virtualizerScrollViewClassNames.container, styles.base, containerStyle, state.container.className);
    return state;
}; //# sourceMappingURL=useVirtualizerScrollViewStyles.styles.js.map
